// extracted by mini-css-extract-plugin
module.exports = {"archiveBody":"styles_archiveBody__RWT7N","archiveFooter":"styles_archiveFooter__1mm4Z","archiveModal":"styles_archiveModal__1a_Is"};